import React from "react";

const OrderPosition = ({ status }) => {
  return (
    <div className="track_order">
      <ul>
        <li
          className={
            status === "pending" ||
            status === "recieved" ||
            status === "process" ||
            status === "ontheway" ||
            status === "delivered"
              ? "active"
              : ""
          }
        >
          Order Pending
        </li>
        <li
          className={
            status === "recieved" ||
            status === "process" ||
            status === "ontheway" ||
            status === "delivered"
              ? "active"
              : ""
          }
        >
          Order Accept
        </li>
        <li
          className={
            status === "process" ||
            status === "ontheway" ||
            status === "delivered"
              ? "active"
              : ""
          }
        >
          Order Process
        </li>
        <li
          className={
            status === "ontheway" || status === "delivered" ? "active" : ""
          }
        >
          On the Way
        </li>
        <li className={status === "delivered" ? "active" : ""}>Completed</li>
      </ul>
    </div>
  );
};

export default OrderPosition;
